import { z } from 'zod';

export const SpecialtySchema = z.object({
  code: z.string(),
  name: z.string(),
});

export type Specialty = z.infer<typeof SpecialtySchema>;
